import { create } from "zustand";
import { ExamInstanceQuestion, ExamInstanceTree, Question, User } from "@types";

export enum ThemeMode {
    Light = "light",
    Dark = "dark",
    System = "system"
}

type ExamStore = {
    theme: ThemeMode;
    setTheme: (theme: ThemeMode, isDark: boolean) => void;
    currentUser?: User; // moze se koristiti bilo gdje unutar aplikacije
    setCurrentUser: (user: User) => void;
    clickedQuestion?: Question;
    clickedExamInstanceQuestion?: ExamInstanceQuestion;
    clickedGroup: number;
    clickedQuestionIndex: number;
    examInstanceLoading: boolean;
    gradingIndex: number;
    currentQuestionIndex: () => number; 
    setClickedExamInstanceQuestion: (val: ExamInstanceQuestion) => void;
    setClickedQuestion: (val: Question) => void;
    setQuestionIndex: (index: number, indexGroup: number) => void;
    setAnswered: (answered: boolean, value: string | string[] | boolean | number) => void;
    getAnswers: (index: number) => string | boolean | string[] | number;
    // jumpToFirstUnanswered: () => void;
    answeredLength: number;
    setAnsweredLength: () => void;
    setStatus: (status: number) => void;
    setPoints: (points: number | null) => void;
    examInstanceTree?: ExamInstanceTree;
    questionsLength: () => number;
    nextQuestion: () => void;
    previousQuestion: () => void;
    setExamInstanceTree: (val: ExamInstanceTree) => void;
}

export const useExamStore = create<ExamStore>((set, get) => ({
    theme: ThemeMode.Light,
    setTheme: (theme, isDark) => {
        if (theme === ThemeMode.Dark) {
            document.documentElement.style.setProperty('--bg-color', "#1f1f1f")
            document.documentElement.style.setProperty('--scrollbar-bg-color', "#141414")
        } else if (theme === ThemeMode.Light) {
            document.documentElement.style.setProperty('--bg-color', "white")
            document.documentElement.style.setProperty('--scrollbar-bg-color', "#f5f5f5")
        } else {
            document.documentElement.style.setProperty('--bg-color', isDark ? "#1f1f1f" : "white")
            document.documentElement.style.setProperty('--scrollbar-bg-color', isDark ? "#141414" : "#f5f5f5")
        }
        localStorage.setItem("theme", theme);
        set(() => ({theme: theme}));
    },
    clickedQuestion: undefined,
    currentUser: undefined,
    setCurrentUser: (user) => {
        set(() => ({currentUser: user}));
    },
    clickedGroup: 0,
    clickedQuestionIndex: 0,
    bookmarkLength: 0,
    examInstanceLoading: false,
    gradingIndex: 1,
    nextQuestion() {
        let found = false;
        get().examInstanceTree?.groups && get().examInstanceTree?.groups.forEach((item, groupIndex) => {
            if (found) return;
            item.questions.forEach((question, questionIndex) => {
                if (found) return;
                if (question.id === get().clickedQuestion?.id) {
                    if (item.questions.length > questionIndex + 1) {
                        get().setQuestionIndex(questionIndex + 1, groupIndex);
                        found = true;
                    } else if (get().examInstanceTree!.groups.length > groupIndex + 1) {
                        get().setQuestionIndex(0, groupIndex + 1);
                        found = true;
                    }
                }
            })
        })

    },
    previousQuestion() {
        let found = false;
        get().examInstanceTree?.groups && get().examInstanceTree?.groups.forEach((item, groupIndex) => {
            if (found) return;
            item.questions.forEach((question, questionIndex) => {
                if (found) return;
                if (question.id === get().clickedQuestion?.id) {
                    if (questionIndex > 0) {
                        get().setQuestionIndex(questionIndex - 1, groupIndex);
                        found = true;
                    } else if (groupIndex > 0) {
                        get().setQuestionIndex(get().examInstanceTree!.groups[groupIndex - 1].questions.length - 1, groupIndex - 1);
                        found = true;
                    }
                }
            })
        })
    },
    setExamInstanceTree(val) {
        set(() => ({examInstanceTree: val}));
        if (get().clickedQuestion === undefined) {
            get().setQuestionIndex(0, 0);
        }
    },
    currentQuestionIndex() {
        let count = 0;
        if (!get().examInstanceTree?.groups) return -1;
        for (const group of get().examInstanceTree?.groups!) {
            for (const question of group.questions!) {
                count++;
                if (question.id === get().clickedQuestion?.id) {
                    set(() => ({gradingIndex: count}));
                    return count;
                }
            }
        }
        return -1;
    },
    setClickedExamInstanceQuestion(val: ExamInstanceQuestion) {
        set((state) => ({clickedExamInstanceQuestion: state.clickedExamInstanceQuestion = val}))

    },
    setClickedQuestion(val: Question) {
        set((state) => ({clickedQuestion: state.clickedQuestion = val}))
       
    },
    setQuestionIndex(index, id) {
        if (index >= 0) {   
            set(() => ({clickedQuestionIndex: index, clickedQuestion: get().examInstanceTree?.groups[id].questions[index], clickedGroup: id}))
            get().currentQuestionIndex();
        } 
    },
    jumpToFirstUnanswered() {
        let found = false;
        get().examInstanceTree?.groups?.forEach((item, indexGroup) => {
            if (found) return;
            item.questions.forEach((question, index) => {
                if (found) return;
                if (question.isAnswered === false) {
                    get().setQuestionIndex(index, indexGroup);
                    found = true;
                }
                
            })
        })
    },
    questionsLength() {
        let count = 0;
        get().examInstanceTree?.groups?.forEach((item) => {
            item.questions?.forEach(() => {
                count++;
            })
        })
        return count;
    },

    getAnswers(index) {
        return get().examInstanceTree?.groups[get().clickedGroup].questions[index].answer!;
    },
    answeredLength: 0,
    setAnsweredLength() {
        let count = 0;
        get().examInstanceTree?.groups.forEach((item) => {
            item.questions?.forEach((question) => {
                if (question.answered) {
                    count++;
                }
            })
        })
        set(() => ({answeredLength: count}));
    },
    setStatus(status) {
        get().examInstanceTree!.groups[get().clickedGroup].questions![get().clickedQuestionIndex].state = status;
    },
    setPoints(points) {
        get().examInstanceTree!.groups[get().clickedGroup].questions![get().clickedQuestionIndex].points = points;
    },
    questions: undefined,
    setAnswered: (_, __) => {
    }
}))